module.exports = __webpack_public_path__ + "static/keyword_3-e0847f8a47ca94938344b0c6f86c8015.jpg";